import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input',
  standalone: true,
})
export class PreserveInputArrowKeysDirective {
  constructor(private elementRef: ElementRef<HTMLInputElement>) {}

  @HostListener('keydown', ['$event'])
  preserveArrowKeys(event: KeyboardEvent): void {
    const isArrowKey =
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown' ||
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight';

    if (
      isArrowKey &&
      this.elementRef.nativeElement.closest('mat-button-toggle-group')
    ) {
      event.stopPropagation();
    }
  }
}
